var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-editor',{attrs:{"fields":_vm.fields,"publication":true,"permission":"press","endpoint":"press","module":"press","previewModule":"pers","selectTags":false,"selectCategories":false},on:{"update":_vm.updateState}})}
var staticRenderFns = []

export { render, staticRenderFns }